import { Box, Button, Divider, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import { formatBytes } from 'src/lib/formatBytes'
import { usePatientFileDownloadUrlLazyQuery } from 'src/participantHistoryForm/form/patientFiles.generated'
import { PatientHistoryEntryFragment } from '../patientHistoryQueries.generated'

type PatientFile = NonNullable<PatientHistoryEntryFragment['files']>[number]

type Props = {
  files: PatientFile[]
}

export default function PatientHistoryFilesPreview({ files }: Props) {
  const [downloadURL] = usePatientFileDownloadUrlLazyQuery()
  const onOpen = useCallback(
    async (fileID: string) => {
      const { data } = await downloadURL({ variables: { fileID } })
      const url = data?.patientFile?.downloadURL
      if (url) {
        window.open(url, '_blank')
      }
    },
    [downloadURL]
  )

  return (
    <Box mt={3}>
      <Divider sx={{ mb: 2 }} />
      <Box display="flex" justifyContent="space-between" alignItems="baseline" mb={1}>
        <Typography variant="subtitle2">Files</Typography>
      </Box>

      {files.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No files attached.
        </Typography>
      ) : (
        <Table size="small" aria-label="patient history files">
          <TableHead>
            <TableRow>
              <TableCell>Filename</TableCell>
              <TableCell align="right">Size</TableCell>
              <TableCell align="right" width={1}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {files.map((file) => (
              <TableRow key={file.fileID}>
                <TableCell>{file.filename}</TableCell>
                <TableCell align="right">{formatBytes(file.size)}</TableCell>
                <TableCell align="right">
                  <Button size="small" variant="outlined" onClick={() => onOpen(file.fileID)}>
                    Open
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  )
}
